<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog-confirm
                :md-active.sync="deleteConfirm"
                md-title="Confirmación"
                md-content="¿Desea elminar este reporte?"
                md-confirm-text="Borrar"
                md-cancel-text="Cancelar"
                @md-cancel="deleteConfirm = false"
                @md-confirm="onDeleteConfirm" />

            <md-table v-model="dumps" md-sort="name" md-sort-order="asc" v-if="!showDialog" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Reportes de Jugadores</h1>

                    <md-content class="text-xs-center" v-if="loading">
                        <p class="md-subheading md-layout md-alignment-top-center" v-bind:style="{ width: '100%' }">Cargando...</p>
                    </md-content>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!loading">
                    <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Cant. Jugadores" md-sort-by="playerCount">{{ item.playerCount }}</md-table-cell>
                    <md-table-cell md-label="Tamaño" md-sort-by="size" style="text-align: center;">{{ item.size }} bytes</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="downloadItem(item)" v-if="acl.downloadsExports">
                            <md-icon>cloud_download</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent" @click="deleteItem(item)" v-if="acl.deletesExports">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
  .md-select-content {
    z-index: 9999;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";

export default {
    name: 'Exports',
    components: {
        Header, Menu
    },
    data: () => ({
        menuVisible: false,
        loading: false,
        deleteConfirm: false,
        deleteItemId: null,
        dumps: [],
        showDialog: false,
        form: {},
        formForEdit: false,
        sending: false,
        lastUser: null,
        acl: {
            deletesExports: false
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.schools = [];
            this.loading = true;
            this.acl = {
                downloadsExports: user.hasPermission('downloadsExports'),
                deletesExports: user.hasPermission('deletesExports'),
            }
            console.log('this.acl', this.acl);

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/exports", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.dumps = result.data;
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        downloadItem (item) {
            window.open(item.downloadUrl);
        },
        deleteItem (item) {
            this.deleteConfirm = true;
            this.deleteItemId = item.id;
        },
        onDeleteConfirm () {
            axios({ 
                "method": "DELETE", 
                "url": config.apiUrl + "/exports/" + this.deleteItemId, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result);
                    this.fetchData();
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Exports.vue